<template>
  <WellsPrice
    v-if="type === 'wells'"
    :regularPrice="maybeAddTax(regularPrice)"
    :salePrice="maybeAddTax(salePrice)"
    :isVariable="isVariable"
    :showPriceRange="showPriceRange"
    v-tax-toggle="toggleTax"
  ></WellsPrice>
</template>

<script>
import WellsPrice from '@/components/general-ui/prices/Wells.vue';

export default {
  name: 'Price',
  components: {
    WellsPrice,
  },
  props: {
    regularPrice: Number,
    salePrice: Number,
    isVariable: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showPriceRange: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  data() {
    return {
      type: ws_vue_store.config.price,
      includingTax: ws_vue_store.including_tax === '1',
      removeTax: this.getTaxToggleCookieValue() == false ? false : this.getTaxToggleCookieValue() == 'taxes_excluded' ? true : false,
      fixedLength: ws_vue_store.fixed_length,
    };
  },
  directives: {
    'tax-toggle': {
      bind(el, binding) {
        window.wsTaxesToggledDirectiveEvent = (event) => binding.value(event);
        document.addEventListener('taxes-toggled', window.wsTaxesToggledDirectiveEvent);
      },
      unbind() {
        document.removeEventListener('taxes-toggled', window.wsTaxesToggledDirectiveEvent);
      },
    },
  },
  methods: {
    maybeAddTax(value) {
      if (Number.isNaN(value) || value === "" || value === undefined) return value;
      if(value === 0) return '';
      if (this.includingTax) {
        if(this.removeTax){
          return this.formatNumber(parseFloat(value) / 1.2) + ' (' + ws_vue_store.translations.excluded_vat + ')';
        } 
      }
      return this.formatNumber(value);
    },
    formatNumber(value) {
      return `${value.toFixed(this.fixedLength).toString().replace('.', ',')} €`;
    },
    toggleTax() {
      this.removeTax = !this.removeTax;
    },
    getTaxToggleCookieValue(){
      const cookieKey = 'ws_taxes_display_selection';
      const cookieName = `${cookieKey}=`;
      const cookieArray = document.cookie.split(';');
      //console.log(cookieArray);
      if (cookieArray.length) {
        // eslint-disable-next-line no-restricted-syntax
        for (let cookie of cookieArray) {
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
          }
          if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
          }
        }
      }
      return false;
    }
  },
};
</script>
